export interface ExtrasMudancaStatus {
    dataTermino?: Date;
    kmFinal?: number;
    observacao?: string;
    /** Venda do veículo ao locatário: só o modal de encerramento informa; nunca vem da linha do grid (DL-181). */
    vendeuVeiculo?: boolean;
}

function extrairPrazo(locacao: any): { valor: any; unidade: any } {
    let bruto = locacao.tempoContratoEmMeses;
    if (typeof bruto === 'string') {
        try {
            bruto = JSON.parse(bruto);
        } catch {
            return { valor: bruto, unidade: locacao.tipoPeriodicidadeTempoContrato };
        }
    }
    if (bruto && typeof bruto === 'object' && bruto.value !== undefined && bruto.unit !== undefined) {
        return { valor: bruto.value, unidade: bruto.unit };
    }
    return { valor: bruto, unidade: locacao.tipoPeriodicidadeTempoContrato };
}

export function montarPayloadMudancaStatus(locacao: any, status: number, extras: ExtrasMudancaStatus = {}): any {
    const prazo = extrairPrazo(locacao);
    return {
        id: locacao.id,
        status,
        idLocatario: locacao.idLocatario,
        idVeiculo: locacao.idVeiculo,
        idEmpresa: locacao.idEmpresa,
        valorAluguel: locacao.valorAluguel,
        valorCaucao: locacao.valorCaucao,
        diaPagamento: locacao.diaPagamento,
        dataInicio: locacao.dataInicio,
        dataTermino: extras.dataTermino,
        kmInicial: locacao.kmInicial,
        kmFinal: extras.kmFinal,
        periodicidadePagamento: locacao.periodicidadePagamento,
        tempoContratoEmMeses: prazo.valor,
        tipoPeriodicidadeTempoContrato: prazo.unidade,
        gerarLancamentoCaucaoComoPago: locacao.gerarLancamentoCaucaoComoPago,
        gerarPagamentoInicialComoPago: locacao.gerarPagamentoInicialComoPago,
        definirPagamentosAnteriorAHojeComoPago: locacao.definirPagamentosAnteriorAHojeComoPago,
        desejoGerarPagamentoUnico: locacao.desejoGerarPagamentoUnico || false,
        // Vencimento é por dia: sem data de pagamento, só o DIA da retirada (a retirada tem hora).
        dataPagamento: locacao.dataPagamento || (locacao.dataInicio ? String(locacao.dataInicio).substring(0, 10) : locacao.dataInicio),
        observacao: extras.observacao || locacao.observacao || "",
        vendeuVeiculo: Boolean(extras.vendeuVeiculo),
        asaasSubscriptionId: locacao.asaasSubscriptionId,
        valorJurosAoDia: locacao.valorJurosAoDia,
        jurosAoMes: locacao.jurosAoMes,
        multaFixa: locacao.multaFixa,
        multaPercentual: locacao.multaPercentual,
        fiador: locacao.fiador,
        opcaoDeCompra: locacao.opcaoDeCompra,
        idBanco: locacao.idBanco,
        asaasTipoDePagamento: locacao.asaasTipoDePagamento,
        descricaoCustomAluguel: locacao.descricaoCustomAluguel,
        limiteQuilometragem: locacao.limiteQuilometragem,
        dataSegundoPagamentoQuinzena: locacao.dataSegundoPagamentoQuinzena,
        ajusteDiaInexistente: locacao.ajusteDiaInexistente,
    };
}
